import { IObject } from 'src/models/interfaces'

export const ROUTES_NAME = {
  common: {
    home: '/',
    pageNotFound: '*',
    profile: 'profile',
    receiveTurn: 'receive-turn',
    counseling: 'counseling',
  },
  public: {
    login: '/login',
  },
  patient: {
    visitRecords: 'visit-records',
    turnRecords: 'turn-records',
    Prescriptions: 'Prescriptions-records',
    timeReserved: 'timeReserved-records',
    onlineConsulingRequest: 'online-consuling-request',
    patientConsultations: 'Consultations',
    patientConsultationChat:'patient-consultation-chat',
    doctorPanel:'doctor-panel',
  },
  doctors: {
    patientList: 'patient-list',
    addPatient: 'patients/create',
    secretaries: 'secretaries',
    electronicPrescription: 'electronic-prescription',
    receptionCashDesk: 'reception-cash-desk',
    visit: 'visit',
    LettersReceived: 'LettersReceived',
    LettersSent: 'LettersSent',
    doctors: 'doctors',
    salamatDeliverPrescribe: 'salamat-Deliver-prescription',
    incomingMessge: 'incoming-messages',
    vitalSign: 'vital-sign',
    reserveTime: 'reserve-time',
    chat: 'chat',
    report: 'report',
    onlineConsultant: 'onlineConsultant',
  },
  insurances: {
    list: 'insurances-list',
    types: 'insurances-types-list',
  },
  panel: {
    sms: 'sms-pay',
    report: 'sms-report',
  },
  jobs: {
    list: 'jobs-list',
  },
  assistants: {
    list: 'assistants-list',
  },
  serviceDetails: {
    list: 'serviceDetails-list',
  },
  materialCenter: {
    list: 'materialCenter-list',
    materialGroup: 'materialCenter-group',
    material: 'material',
    reception: 'material-reception',
  },
  banks: {
    list: 'banks-list',
  },
  notifications: {
    list: 'notifications-list',
  },
  Contacts: {
    list: 'contacts-list',
    group: 'contacts-group-list',
  },
  disease: {
    list: 'disease-list',
  },
  departments: {
    list: 'departments-list',
  },
  warehouse: {
    list: 'warehouse-list',
    bill: 'warehouse-bill',
    saleFactors: 'warehouse-SaleFactors',
    unit: 'warehouse-Materialunit',
    transfer: 'warehouse-transfer',
  },
  Payment: {
    Patient: 'Payment-to-Patient',
    bank: 'Payment-to-bank',
  },
  Accounting: {
    persons: 'accounting-person',
    Officialduc: 'accounting-Officialduc',
    DocumentsList: 'accounting-Documents-List',
  },
}

export const PAGE_TITLES: IObject = {
  '/profile': 'حساب کاربری',
  '/counseling': 'مشاوره',
  '/login': 'ورود',
  '/visit-records': 'ویزیت های من',
  '/Prescriptions-records': 'نسخه های من',
  '/timeReserved-records': 'نوبت های من',
  '/patient-list': 'بیماران',
  '/secretaries': 'منشی ها',
  '/electronic-prescription': 'نسخه الکترونیک',
  '/reception-cash-desk': 'پذیرش-صندوق',
  '/visit': 'ویزیت',
  '/LettersReceived': 'نامه های دریافتی',
  '/LettersSent': 'درخواست های ارسالی',
  '/doctors': 'پزشکان',
  '/salamat-Deliver-prescription': 'ارائه خدمات بیمه سلامت',
  '/incoming-messages': 'پیام های دریافتی',
  '/vital-sign': 'علایم حیاتی',
  '/reserve-time': 'رزرو نوبت',
  '/chat': 'گفتگو',
  '/report': 'گزارشات',
  '/insurances-list': 'بیمه ها',
  '/insurances-types-list': 'انواع دفترچه',
  '/sms-pay': 'پنل پیامک',
  '/sms-report': 'گزارش ارسال پیامک',
  '/jobs-list': 'مشاغل',
  '/assistants-list': 'دستیاران',
  '/serviceDetails-list': 'کدینگ خدمات',
  '/materialCenter-list': 'اقلام مصرفی مرکز',
  '/materialCenter-group': 'گروه مواد مصرفی',
  '/material': 'کدینگ مواد مصرفی',
  '/material-reception': 'اقلام مصرفی پذیرش',
  '/banks-list': 'بانک ها',
  '/notifications-list': '',
  '/contacts-list': 'مخاطبان',
  '/contacts-group-list': 'گروه مخاطبان',
  '/disease-list': 'بیماری خاص',
  '/departments-list': 'مدیریت بخش ها',
  '/warehouse-list': 'لیست انبار ها',
  '/warehouse-bill': 'رسید انبار',
  '/warehouse-SaleFactors': 'فاکتور فروش',
  '/warehouse-Materialunit': 'واحد کالا',
  '/warehouse-transfer': 'حواله بین انبار',
  '/Payment-to-Patient': 'حواله پرداخت',
  '/Payment-to-bank': 'حواله دریافت',
  '/online-consuling-request': 'درخواست مشاوره آنلاین',
  '/onlineConsultant': 'مشاوره آنلاین',
  '/Consultations': "مشاوره های من",
  '/patient-consultation-chat': "مشاوره",
  '/doctor-panel': "پزشک",
  '/receive-turn':"ثبت نوبت"
}
